<template>
    <div>
      <b-navbar toggleable="lg" type="dark" variant="danger" class="fixed-top">
        <b-container fluid>
            <b-navbar-brand href="#">Catálogo-Materiales</b-navbar-brand>
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <!-- Right aligned nav items -->
              <b-navbar-nav class="ml-auto">
                <b-nav-form>
                  <b-form-select v-model="familiaFiltro" :options="familias" size="sm" class="my-2 my-sm-0 mr-2"></b-form-select>
                  <b-form-input 
                    size="sm" 
                    class="mr-sm-2" 
                    placeholder="Texto"
                    v-model="terminoFiltro"
                    ></b-form-input>
                  <b-button 
                    variant="warning"
                    size="sm" 
                    class="my-2 my-sm-0" 
                    type="submit" 
                    @click.prevent="filtrar"
                    >Buscar</b-button>
                </b-nav-form>
              </b-navbar-nav>
            </b-collapse>
          </b-container>
      </b-navbar>
    </div>  
</template>

<script>
  export default {
    data() {
      return {
          terminoFiltro: '',
          familiaFiltro: 'TODAS LAS FAMILIAS'
      }
    },
    methods: {
      filtrar() {
          console.log(this.terminoFiltro);
          console.log(this.familiaFiltro);
          this.$store.commit('filtrar', {terminoFiltro: this.terminoFiltro, familiaFiltro: this.familiaFiltro})
      }
    },
    computed: {
      familias: function(){
        return ['TODAS LAS FAMILIAS'].concat(this.$store.state.registros.map(function (registro){
          return registro.FAMILIA;
        }).filter((v, i, a) => a.indexOf(v) === i));
      }
    }
  }
</script>